<template>
  <el-select
    ref="customer"
    v-model="selected"
    placeholder="Selecione  uma opção"
    @change="update()"
  >
    <el-option
      v-for="row of types"
      :key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { FinancialTypeService } from "@/services/customers/financial.type.services";
export default {
  name: "FinancialTypeList",
  data: function () {
    return {
      types: [],
      selected: "",
    };
  },
  watch: {
    current() {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  props: {
    current: String,
  },
  methods: {
    fetch() {
      const vm = this;
      FinancialTypeService.list()
        .then((response) => {
          vm.types = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 300);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>